import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_USER_GUIDE, SET_USER_GUIDE, USER_GUIDE_REQUEST_FAILED, SENDING_USER_GUIDE_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getUserGuide(action) {
  const { data } = action;
  try {
    yield put({
      type: SENDING_USER_GUIDE_REQUEST,
      ugData: '',
      isUgSending: true,
      isUgSuccess: false,
      ugError: false,
    });
    const response = yield call(api.userGuide, data);
    // console.log(response);
    if (response) {
      yield put({
        type: SET_USER_GUIDE,
        ugData: response.toString(),
        isUgSending: false,
        ugError: false,
        isUgSuccess: true,
      });
    } else {
      yield put({
        type: USER_GUIDE_REQUEST_FAILED,
        ugData: null,
        isUgSending: false,
        ugError: true,
        isUgSuccess: false,
        ugMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: USER_GUIDE_REQUEST_FAILED,
      ugMsg: e.message,
      isUgSending: false,
      ugError: true,
      isUgSuccess: false,
      ugData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetUserGuide() {
  yield takeLatest(GET_USER_GUIDE, getUserGuide);
}
